import Navbar from '../Navbar/Navbar'
import './Header.css'

const Header = () => {

  return (
    <header className='header center'>
      <Navbar />
    </header>
  )
}

export default Header
